

import styled from 'styled-components'
import SingleRouteMap from '../../map/SingleRouteMap'
import { IoMdClose } from "react-icons/io";
import { useSelector } from 'react-redux';
import { showModal, showNestedModal } from '../../../features/modal/modalSlice';
import { useDispatch } from 'react-redux';
import Btn from '../../shared/button/Btn';
import { BsFillExclamationCircleFill } from "react-icons/bs";
import { useState } from 'react';
import InputSelectAdres from '../../shared/input/special/InputSelectAdres';
import { useEffect } from 'react';
import { getAdresAutoComplete, setAdresAutoComplete } from '../../../features/address/addressSlice';
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete';
import { handleActiveSelect } from '../../../features/layout/layoutSlice';
import locationData from '../../../utils/locationData/locationOptions';
import addLoadLocationData from '../../../utils/locationData/addLoadLocationOptions';
import { setSelectedRouteItemUpdate, updateRouteItem } from '../../../features/updateLoad/updateLoadSlice';
import SingleRouteMapUpdate from '../../map/SingleRouteMapUpdate';
const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

  .modal {
    width: auto;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    padding: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .content {
      width: 650px;
      height: 100%;
      display: flex;
      flex-direction: column;
      
      .top-container{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        .h2{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-xl);
        }

        .close-icon{
            font-size: 1.4rem;
            cursor: pointer;
            color: ${({theme}) => theme.mainTextColor};
        }
      }

      .desc{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        margin-bottom: 30px;
      }

      .input-container{
        margin-bottom: 20px;
      }

      .exc-container{
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: ${({theme}) => theme.secondaryBgColor};
        padding: 15px 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);

        .exc-icon{
          margin-right: 5px;
          fill: #636161;

        }
      }

      .map-container{
        width: 100%;
        min-width: 400px;
        height: 350px;
      }

      .bottom-container{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;

        span{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
        }
      }

    }
  }
`

const SingleRouteMapUpdateModal = () => {

  const { selectedRouteItemUpdate, selectedRouteItemTypeUpdate, route } = useSelector((state) => state.updateLoad);
  const {adresAutoCompleteOptions} = useSelector(state => state.address)

  const dispatch = useDispatch()

  const [selected, setSelected] = useState(null)

    useEffect(()=> {
      if(selectedRouteItemUpdate?.locationData?.googleSearchText?.length > 0){
        dispatch(getAdresAutoComplete({searchText: selectedRouteItemUpdate.locationData?.googleSearchText}))
      }
      else{
        dispatch(setAdresAutoComplete([]))
      }
    },[selectedRouteItemUpdate?.locationData?.googleSearchText])

    useEffect(() => {
      if(selected){
        getCoordinates(selected.description)
      }
    },[selected])

    const getCoordinates = async() => {
      try {
        const results = await getGeocode({ address:selected.description });
        const { lat, lng } = await getLatLng(results[0]);
        
        dispatch(setSelectedRouteItemUpdate({...selectedRouteItemUpdate, locationData: {...selectedRouteItemUpdate.locationData, googleLat: lat, googleLng: lng, googleSearchText: selected.description, googleLocation: selected.description, isfirstChanged: true }}));
        // dispatch(setAdresSelectMapZoom(12))
      } 

      catch (error) {
          // console.log(error);
      }
    }

    const handleSubmit = () => {

      //! route içinden ilgili routeItem 
      const currentItem = route.find(item => item.id === selectedRouteItemUpdate.id)

      const locationItem = addLoadLocationData.find(item => {
        return selectedRouteItemUpdate?.locationData?.googleLocation.includes(item.city) && selectedRouteItemUpdate?.locationData?.googleLocation.includes(item.town)
      })

      dispatch(updateRouteItem({...selectedRouteItemUpdate,
        adres: currentItem?.adres ? currentItem?.adres : selectedRouteItemUpdate?.locationData?.googleLocation, 
        locationData: {
        ...selectedRouteItemUpdate?.locationData,

        il: locationItem?.city,
        ilId: locationItem?.cityId,
        ilce: locationItem?.town,
        ilceId: locationItem?.townId,
        bolge: locationItem?.region,
        location: locationItem?.location,
        lat: selectedRouteItemUpdate?.locationData?.googleLat,
        lng: selectedRouteItemUpdate?.locationData?.googleLng,


        googleLocation: selectedRouteItemUpdate?.locationData?.googleLocation,
        isGoogleAddressSelected: true,
        googleLat: selectedRouteItemUpdate?.locationData?.googleLat,
        googleLng: selectedRouteItemUpdate?.locationData?.googleLng,
       }}));

       dispatch(showNestedModal(null))
       dispatch(setSelectedRouteItemUpdate(null))
       dispatch(setAdresAutoComplete([]))

    } 


    const handleClose = () => {

      dispatch(showNestedModal(null))
      // const currentItem = route.find(item => item.id === selectedRouteItemUpdate.id)

      // if(
      //   currentItem.locationData.il === selectedRouteItemUpdate.locationData.il &&
      //   currentItem.locationData.ilId === selectedRouteItemUpdate.locationData.ilId &&
      //   currentItem.locationData.ilce === selectedRouteItemUpdate.locationData.ilce &&
      //   currentItem.locationData.ilceId === selectedRouteItemUpdate.locationData.ilceId &&
      //   currentItem.locationData.lat === selectedRouteItemUpdate.locationData.lat &&
      //   currentItem.locationData.lng === selectedRouteItemUpdate.locationData.lng &&
      //   currentItem.locationData.googleLat === selectedRouteItemUpdate.locationData.googleLat &&
      //   currentItem.locationData.googleLng === selectedRouteItemUpdate.locationData.googleLng &&
      //   currentItem.locationData.googleLocation === selectedRouteItemUpdate.locationData.googleLocation &&
      //   currentItem.locationData.location === selectedRouteItemUpdate.locationData.location &&
      //   currentItem.locationData.ilce === selectedRouteItemUpdate.locationData.ilce
      // ){
      //   dispatch(showModal(null))
      //   dispatch(setSelectedRouteItemUpdate(null))
      //   dispatch(setAdresAutoComplete([]))
      // }
      // else{
      //   dispatch(showNestedModal("addLoadRouteItemNotSavedDesc"))
      // }
    }
    
    const handleTextChange = (e) => {

      dispatch(setSelectedRouteItemUpdate({...selectedRouteItemUpdate, locationData: {...selectedRouteItemUpdate?.locationData, googleSearchText: e?.target?.value }}))
    }

    
  return (
    // <Container>
    <Container onClick={handleClose}>
        <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
            <div className="content">
                <div className="top-container">
                    <h2 className='h2'>Tam konumunuz nedir?</h2>
                    <IoMdClose className='close-icon' onClick={handleClose}/>
                </div>
                <p className="desc">Tam Konum girmeniz sorunsuz sevkiyat işlemi ve sefer konum takibi için önemlidir.</p>
                <div className="input-container">
                    <InputSelectAdres text={selectedRouteItemUpdate?.locationData?.googleSearchText} setText={(e) => handleTextChange(e)} selected={selected} setSelected={setSelected} labelText={"Adres Girin"} options={adresAutoCompleteOptions} inputWidth={"100%"}/>
                </div>
                <div className="exc-container">
                  <BsFillExclamationCircleFill className='exc-icon'/>
                  Haritada imleci {selectedRouteItemUpdate ? "Yükleme" : "Boşaltma"} noktasına getirin
                </div>
                <div className="map-container">
                    <SingleRouteMapUpdate routeItem={selectedRouteItemUpdate}/>
                </div>
                <div className="bottom-container">
                  <span>{selectedRouteItemUpdate?.locationData?.googleLocation ? `Seçilen Adres: ${selectedRouteItemUpdate?.locationData?.googleLocation}` : "Adres Girin"}</span>
                  <Btn color='#fff' bgColor={selectedRouteItemUpdate?.locationData?.googleLocation ? '#E85446' : '#7c7b7b'} isDisabled={!selectedRouteItemUpdate?.locationData?.googleLocation} handleClick={handleSubmit} borderColor='none' width={"140px"}>Bu Adresi Kullan</Btn>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default SingleRouteMapUpdateModal